import Checkbox from '@/components/ui/custom/dataInput/Checkbox';
import { Project } from '@/models/Project';
import { hasFinalistTag } from '@/utils/hackathon';
import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { useFinalist } from './HackathonFinalistAction.hooks';

type HackathonFinalistProps = {
  project: Project;
  onMutate?: (project: Project) => void;
};

export default function HackathonFinalistAction({
  project,
  onMutate,
}: HackathonFinalistProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'projects.card.actions',
  });

  const { setFinalist, isUpdating } = useFinalist(project, onMutate);
  const isFinalist = hasFinalistTag(project);

  const handleClick: MouseEventHandler<HTMLInputElement> = e => {
    e.stopPropagation();
    e.preventDefault();
    setFinalist();
  };

  return (
    <Checkbox
      color="custom"
      checked={isFinalist}
      id="setFinalist"
      className={{
        div: 'shrink-0',
      }}
      label={t('finalist')}
      onClick={handleClick}
      loading={isUpdating}
    />
  );
}
